export class CompanyDto {
    constructor(factor_id, name) {
        this.id = factor_id;
        this.name = name;
    }
}